import { useMeeting } from "@videosdk.live/react-sdk";
import { useEffect, useRef } from "react";
import { useMeetingAppContext } from "../MeetingAppContextDef";

const useLivestreamHook = () => {
  const mMmeeting = useMeeting();

  const { startliveStreaming, setstartLivestreaming } = useMeetingAppContext();

  const _handleliveStarted = () => {
    setstartLivestreaming(true);
  };

  const _handleliveStopped = () => {
    setstartLivestreaming(false);
  };

  useEffect(() => {
    if (mMmeeting?.meeting) {
      mMmeeting?.meeting?.on("livestream-started", _handleliveStarted);
      mMmeeting?.meeting?.on("livestream-stopped", _handleliveStopped);

      // return () => {
      //   mMmeeting?.meeting?.off("whiteboard-started", _handleWhiteboardStarted);
      //   mMmeeting?.meeting?.off("whiteboard-stopped", _handleWhiteboardStopped);
      // };
    }
  }, [mMmeeting]);
};

export default useLivestreamHook;
